const Home = (function () {

    let body, win;
    let home, main;
    let keywordSamplesEl, keywordSamplesTemplate;
    let data;
    let positions = [];

    const activeClassName = '-is-active';

    function init () {
        body = $('body');
        win = $(window);
        home = $('#home');
        main = $('#main');
        keywordSamplesTemplate = Handlebars.compile( $('#keywords-sampler-template').html() );
        keywordSamplesEl = $('.keywords-teaser .keywords');
        data = Data.getData();
        renderKeywordSamples();
        registerEvents();
        scatterKeywords();
    }


    function start () {
        home.removeClass(activeClassName);
        main.addClass(activeClassName);
        Visualisation.getGlobe().animate();
    }


    function renderKeywordSamples () {
        let keywords = Object.keys(data.keywords).reduce((acc, item, idx) => {
            if (idx >= 40) {
                return acc.concat([{name: item}]);
            }
            return acc;
        }, []);
        keywords = shuffle(keywords)
            .map((keyword) => {
                const keywordValues = data.keywords[keyword.name];
                const magnitudeSum = keywordValues.reduce((acc, item) => {
                    let parsed = parseFloat(item);
                    if (isNaN(parsed)) return acc;
                    return acc + parsed;
                }, 0);
                return {
                    name: keyword.name,
                    averageMagnitude: magnitudeSum / (keywordValues.length / 2),
                }
            })
            .filter(x => x.averageMagnitude >= 0.02)
            .slice(0,50);
        const markup = $(keywordSamplesTemplate(keywords));
        keywordSamplesEl.html(markup);

        setTimeout(function () {
            markup.filter('.keyword').toArray().map($).forEach(el => {
                el.removeClass('-hidden');
            });
        });
    }


    /**
     * Shuffles array in place. ES6 version
     * @param {Array} a items An array containing the items.
     */
    function shuffle(a) {
        for (let i = a.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [a[i], a[j]] = [a[j], a[i]];
        }
        return a;
    }


    function scatterKeywords() {
        positions = [];
        // The area of the logo and copy
        const clear = {w:550, h:500};
        const container = keywordSamplesEl.parent();
        const containerWidth = container.width();
        const containerHeight = container.height();
        const clearMin = { x: (containerWidth / 2) - (clear.w / 2), y: 0};
        const clearMax = { x: (containerWidth / 2) + (clear.w / 2), y: 500};
        positions = generatePositionsArray(containerWidth, containerHeight, 200, 50);
        let keywordEls = keywordSamplesEl.find('.keyword').toArray().map($);
        let pickedPositions = [];
        let pos = getRandomPosition(positions, true);
        while (pos) {
            pos = getRandomPosition(positions, true);
            if (!pos) continue;
            if (isInsideBounds(pos, clearMin, clearMax)) {
                continue;
            }
            pickedPositions.push(pos);
        }
        pickedPositions.forEach((obj, idx) => {
            if (!keywordEls[idx]) return;
            if (!obj) return;
            keywordEls[idx].css({
                left: obj.x,
                top: obj.y,
            });
        });
    }


    // Returns a random integer between min (included) and max (excluded)
    // Using Math.round() will give you a non-uniform distribution!
    function getRandomInt(min, max) {
        return Math.floor(Math.random() * (max - min)) + min;
    }

    // generate random positions
    function generatePositionsArray(maxX, maxY, safeRadius, irregularity) {
        // declarations
        var positionsArray = [];
        var r, c;
        var rows;
        var columns;
        // count the amount of rows and columns
        rows = Math.floor(maxY / safeRadius);
        columns = Math.floor(maxX / safeRadius);
        // loop through rows
        for (r = 1; r <= rows; r += 1) {
            // loop through columns
            for (c = 1; c <= columns; c += 1) {
                // populate array with point object
                positionsArray.push({
                    x: Math.round(maxX * c / columns) + getRandomInt(irregularity * -1, irregularity),
                    y: Math.round(maxY * r / rows) + getRandomInt(irregularity * -1, irregularity)
                });
            }
        }
        // return array
        return positionsArray;
    }


    // get random position from positions array
    function getRandomPosition(array, removeTaken) {
        // declarations
        var randomIndex;
        var coordinates;
        // get random index
        randomIndex = getRandomInt(0, array.length - 1);
        // get random item from array
        coordinates = array[randomIndex];
        // check if remove taken
        if (removeTaken) {
            // remove element from array
            array.splice(randomIndex, 1);
        }
        // return position
        return coordinates;
    }


    function isInsideBounds (pos, min, max, buffer = 0) {
        return (pos.x + buffer >= min.x) && (pos.y + buffer >= min.y) && (pos.x - buffer <= max.x) && (pos.y - buffer <= max.y)
    }


    function registerEvents () {
        body.on('click.start', '#start', start);
        win.on('resize.scatterKeywords', scatterKeywords);
    }

    return {
        init: init,
    }
})()
